import { render, staticRenderFns } from "./NewResponder.vue?vue&type=template&id=15c62142"
import script from "./NewResponder.vue?vue&type=script&lang=js"
export * from "./NewResponder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports